import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Typography from '@/components/base/Typography'

import { cn } from '@/lib/utils'
import { WPPageData } from '@/types'

export type TableProps = HTMLAttributes<HTMLElement> &
  Partial<{
    theme: WPPageData['acf']['theme']
    pretitle: string
    title: string
    items: {
      row: {
        label: string
        value: string
      }
    }[]
  }>

const Table = ({
  theme = 'light',
  pretitle,
  title,
  items,
  className
}: TableProps) => (
  <section
    className={cn(
      theme === 'dark' ? 'bg-dark-600 text-white' : 'bg-white text-dark-500',
      className
    )}
  >
    <Container>
      <div className="mx-auto max-w-[114.4rem]">
        {(pretitle || title) && (
          <div className="mb-[3.2rem] flex flex-col gap-[0.8rem]">
            {pretitle && (
              <Typography variant="label" className="font-extrabold">
                {pretitle}
              </Typography>
            )}
            {title && (
              <Typography component="h2" variant="h2" className="font-normal">
                {title}
              </Typography>
            )}
          </div>
        )}
        <dl
          className={cn(
            'border-t',
            theme === 'dark' ? 'border-white/15' : 'border-dark-500/15'
          )}
        >
          {items?.map(({ row }, index) => (
            <div
              key={`${row.label}-${index}`}
              className={cn(
                'flex min-h-[12.4rem] flex-col justify-center gap-[1.6rem] border-b py-[3.2rem] md:flex-row md:items-center md:justify-between',
                theme === 'dark' ? 'border-white/15' : 'border-dark-500/15'
              )}
            >
              <dt className="text-small font-extrabold uppercase">
                {row.label}
              </dt>
              <dd className="text-body md:text-right">{row.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </Container>
  </section>
)

export default Table
